<script setup>
import { HoverCardTrigger, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: undefined },
  as: { type: [String, Object], default: undefined },
});

const forwardedProps = useForwardProps(props);
</script>

<template>
  <HoverCardTrigger v-bind="forwardedProps" data-slot="hover-card-trigger">
    <slot />
  </HoverCardTrigger>
</template>
